import { useCallback } from 'react';

import { searchCriteriaForIds } from '@/components/search/v1/utils/helpers';
import { WerklijnenInline, WerklijnInline } from '@/types/werklijnenInline';

import { useFetchAdvancedSearchApi } from './useAdvancedSearchApi';

export const useFetchWerklijnenOpId = () => {
  const { fetchAdvancedSearchApi } = useFetchAdvancedSearchApi();

  // Vraag 1 of meerdere werklijnen op, resultaat is een Promise dat resolved
  // naar array van werklijn-objecten, of een lege [] als de werklijn niet gevonden kon worden:
  const fetchWerklijnenOpIds = useCallback(
    async (ids: string[]) => {
      const response = await fetchAdvancedSearchApi(searchCriteriaForIds(ids));
      if (response.status > 499) {
        console.error(`Serverfout bij ophalen werklijn n.a.v. event: ${response.status}: ${response.statusText}`);
        throw Error('Serverfout');
      } else if (!response.ok) {
        console.error(`Fout bij ophalen werklijn n.a.v. event: ${response.status}: ${response.statusText}`);
        throw Error('Clientfout');
      }
      const json = await response.json();
      const result = json as WerklijnenInline;
      if (result?.werklijnen?.length === 0) {
        return [];
      }
      return result.werklijnen as WerklijnInline[];
    },
    [fetchAdvancedSearchApi],
  );

  // Vraag een enkele werklijn op, resultaat is een Promise dat resolved
  // naar een enkel werklijn-object of `null`:
  const fetchEnkeleWerklijnOpId = useCallback(
    async (id: string) => {
      const werklijnen = await fetchWerklijnenOpIds([id]);
      if (werklijnen.length === 0) {
        throw Error('Werklijn niet gevonden');
      }
      if (werklijnen.length === 1) {
        return werklijnen[0];
      }
      throw Error('Meerdere werklijnen ontvangen met maar 1 id');
    },
    [fetchWerklijnenOpIds],
  );

  return { fetchEnkeleWerklijnOpId, fetchWerklijnenOpIds };
};
